import { SxProps } from '@mui/material'

export default {
  container: {
    container: {
      margin: '0 auto',
    },
  },
  titleContainer: {
    marginBottom: 3,
    textAlign: 'center',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    margin: { sm: '0 auto' },
    paddingTop: 3,
    paddingBottom: 6,
    textAlign: 'center',
  },
  emailButton: {
    width: '100%',
  },
  whatsAppButton: {
    backgroundColor: '#25D366',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1DBF60',
    },
  },
} satisfies SxProps
